/**
 * @description 정수만 허용하는 단일 룰
 * @param v 입력값
 * @returns 정수 여부
 */
export const integerRules = (v) => {
    return (!!v && Number.isInteger(Number(v))) || "정수를 입력하세요";
};
export const maxRule = (max) => {
    return (v) => v <= max || `최대 ${max}까지 입력할 수 있습니다.`;
};
/**
 * @description 필수 정수 입력 검사
 * @param v 입력값
 * @returns 필수 정수 입력 여부
 */
export const requiredIntegerRule = (v) => {
    const n = Number(v);
    if (v === "" || v == null)
        return "값을 입력해주세요.";
    if (!Number.isInteger(n))
        return "정수만 입력하세요.";
    return true;
};
/**
 * @description 0 이상의 정수만 허용하는 단일 룰
 * @param v 입력값
 * @returns 0 이상의 정수 여부
 */
export const positiveIntegerRule = (v) => {
    const n = Number(v);
    if (v === "" || v == null)
        return "값을 입력해주세요.";
    if (!Number.isInteger(n))
        return "정수만 입력하세요.";
    if (n < 0)
        return "0 이상의 값을 입력하세요.";
    return true;
};
/**
 * @description 1 이상의 정수만 허용하는 단일 룰
 * @param v 입력값
 * @returns 1 이상의 정수 여부
 */
export const minOneIntegerRule = (v) => {
    const n = Number(v);
    if (v === "" || v == null)
        return "값을 입력해주세요.";
    if (!Number.isInteger(n))
        return "정수만 입력하세요.";
    if (n < 1)
        return "1 이상의 값을 입력하세요.";
    return true;
};
/**
 * @description 양수이며 소수점 3자리까지 허용하는 단일 룰
 * @param v 입력값
 * @returns 유효성 결과
 */
export const positiveDecimal3Rule = (v) => {
    if (v === "" || v == null)
        return "값을 입력해주세요.";
    const s = String(v).trim();
    if (!/^\d+(\.\d{1,3})?$/.test(s))
        return "소수점 3자리까지의 양수만 입력하세요.";
    const n = Number(s);
    if (!Number.isFinite(n))
        return "유효한 숫자가 아닙니다.";
    if (n <= 0)
        return "0보다 큰 값을 입력하세요.";
    return true;
};
/**
 * @description 필수 입력 검사
 * @param v 입력값
 * @returns 필수 입력 여부
 */
export const requiredInputRule = (v) => {
    return !!v || "필수 입력";
};
/**
 * @description 이메일 형식 검사
 * @param v 입력값
 * @returns 이메일 형식 여부
 */
export const emailFormatRule = (v) => {
    const valid = /.+@.+\..+/.test(v);
    return valid || "이메일 형식 확인";
};
/**
 * @description 전화번호 형식 검사
 * @param v 입력값
 * @returns 전화번호 형식 여부
 */
export const phoneNumberFormatRule = (v) => {
    const valid = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/.test(v);
    return valid || "번호 형식 확인(ex : 010-1234-5678)";
};
/**
 * @description 입고수량이 출고수량보다 큰지 검사
 * @param v 입고수량
 * @param outboundNum 출고수량
 * @returns 입고수량이 출고수량보다 큰지 여부
 */
export const inboundGreaterThanOutboundRule = (v, outboundNum) => v <= outboundNum ||
    `재입고수량은 출고수량(${outboundNum})보다 같거나 작아야 합니다.`;
/**
 * @description 출고 수량이 재고 수량보다 작은지 검사
 * @param v 출고 수량
 * @param stockNum 재고 수량
 * @returns 출고 수량이 재고 수량보다 작은지 여부
 */
export const outboundNumRules = (v, stockNum) => {
    return (!!(Number(v) <= Number(stockNum)) ||
        `출고 수량은 재고 수량(${stockNum})보다 같거나 작아야 합니다.`);
};
/**
 * @description 구매 요청 수량이 유효한지 검사
 * @param v 구매 요청 수량
 * @param num 필요 수량
 * @param stockNum 재고 수량
 * @returns 구매 요청 수량이 유효한지 여부
 */
export const purchaseNumRule = (v, num, stockNum) => {
    const usableNum = Number(stockNum) - Number(num);
    if (usableNum < 0 && v < Math.abs(usableNum) + 1) {
        return `구매 요청 수량은 ${Math.abs(usableNum) + 1}개 이상이어야 합니다.`;
    }
    return true;
};
export const splitNumRule = (v, purchaseNum) => {
    if (v > purchaseNum)
        return "프로젝트 연결 수량은 구매 요청 수량보다 작아야 합니다.";
    return true;
};
export const emptyPasswordRule = (v) => {
    return !!v || "비밀번호 입력";
};
export const passwordFormatRule = (v) => {
    return (!!(v && /^(?=.*[a-zA-z])(?=.*[0-9]).{8,16}$/.test(v)) ||
        "영문 + 숫자, 8자 이상 16자 이하");
};
export const checkPasswordRule = (v, newPassword) => {
    return !!(v == newPassword) || "새 비밀번호와 일치하지 않습니다.";
};
